/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsMappingGroup
 */
export interface EfsMelcoEfsModelsMappingGroup {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingGroup
     */
    group_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingGroup
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingGroup
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingGroup
     */
    format_detail_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingGroup
     */
    reg_expression_id?: string | null;
}

export function EfsMelcoEfsModelsMappingGroupFromJSON(json: any): EfsMelcoEfsModelsMappingGroup {
    return EfsMelcoEfsModelsMappingGroupFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsMappingGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsMappingGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group_type': !exists(json, 'group_type') ? undefined : json['group_type'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'format_detail_id': !exists(json, 'format_detail_id') ? undefined : json['format_detail_id'],
        'reg_expression_id': !exists(json, 'reg_expression_id') ? undefined : json['reg_expression_id'],
    };
}

export function EfsMelcoEfsModelsMappingGroupToJSON(value?: EfsMelcoEfsModelsMappingGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group_type': value.group_type,
        'type': value.type,
        'value': value.value,
        'format_detail_id': value.format_detail_id,
        'reg_expression_id': value.reg_expression_id,
    };
}


